import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

/** 获取url **/
export function getRedirectUrl () {
  return request.request({
    url: '/api/cashier/redirectUrl',
    method: 'POST',
    data: { wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken }
  })
}

/** 获取url **/
export function getChannelUserId (redirectData) {
  return request.request({
    url: '/api/cashier/channelUserId',
    method: 'POST',
    data: Object.assign({ wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken }, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount) {
  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: {
      wayCode: wayCode.getPayWay().wayCode,
      token: config.cacheToken,
      amount: amount,
      channelUserId: channelUserIdUtil.getChannelUserId()
    }
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo () {
  return request.request({
    url: '/api/cashier/payOrderInfo',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 取消订单 **/
export function cancelPay () {
  return request.request({
    url: '/api/cashier/cancelPay',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

export function payOrder(token, data) {
  return request.request({
    url: '/api/pay/byOrder/' + token,
    method: 'POST',
    data
  })
}

export function redirectCashier(token) {
  return request.request({
    url: '/api/pay/redirect/order',
    method: 'POST',
    data: {
      token
    }
  })
}

export function getOrderInfo (token) {
  return request.request({
    url: '/api/cashier/orderInfo',
    method: 'POST',
    data: {
      token: token
    }
  })
}

export function getCaptcha(token, ifCode, data) {
  return request.request({
    url: `/api/captcha/send/${ifCode}/${token}`,
    method: 'POST',
    data
  })
}

export function checkOrderStatus(orderNo) {
  return request.request({
    url: '/api/pay/fast-query/' + orderNo,
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

export function pageStay(orderNo) {
  return request.request({
    url: `/api/pay/stay/${orderNo}`,
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}
